import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'attach_department_lists';
export const useAttachDepartmentListsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Добавить',
    search_placeholder: 'Название списка',
    loading: 'Загрузка',
    empty: 'Нет доступных списков',
    load_error: 'Не удалось загрузить списки',
    on_success: 'Список прикреплён',
    on_error: 'Не удалось прикрепить список',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Add',
    search_placeholder: 'List name',
    loading: 'Loading',
    empty: 'No lists available',
    load_error: 'Failed to load lists',
    on_success: 'List attached',
    on_error: 'Failed to attach list',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Agregar',
    search_placeholder: 'Nombre de lista',
    loading: 'Cargando',
    empty: 'No hay listas disponibles',
    load_error: 'No se pudieron cargar las listas',
    on_success: 'Lista adjuntada',
    on_error: 'No se pudo adjuntar la lista',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Adicionar',
    search_placeholder: 'Nome da lista',
    loading: 'Carregando',
    empty: 'Nenhuma lista disponível',
    load_error: 'Falha ao carregar as listas',
    on_success: 'Lista anexada',
    on_error: 'Falha ao anexar a lista',
  },
}) as Record<string, unknown>;
